import { render, staticRenderFns } from "./XcqImage.vue?vue&type=template&id=3bd1d0e6&scoped=true"
import script from "./XcqImage.vue?vue&type=script&lang=ts"
export * from "./XcqImage.vue?vue&type=script&lang=ts"
import style0 from "./XcqImage.vue?vue&type=style&index=0&id=3bd1d0e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd1d0e6",
  null
  
)

export default component.exports